import { DepartureBoardFilterState } from '../../../store/features/departureBoard/departureBoardSlice';
import { TFunction } from 'i18next';

export const getAppliedFiltersCount = (filterState: DepartureBoardFilterState) => {
    const selectedDepartureStatuses = Object.keys(filterState.departureStatuses).filter(
        (k) => filterState.departureStatuses[k]
    );
    const selectedArrivalAirports = Object.keys(filterState.arrivalAirports).filter(
        (k) => filterState.arrivalAirports[k]
    );
    const selectedDepartureAirports = Object.keys(filterState.departureAirports).filter(
        (k) => filterState.departureAirports[k]
    );

    return (
        selectedDepartureStatuses.length +
        selectedArrivalAirports.length +
        selectedDepartureAirports.length +
        (!!filterState.flightsCheckedInStatus ? 1 : 0) +
        (!!filterState.delayedBaggageStatus ? 1 : 0) +
        (!!filterState.misconnectedCustomersStatus ? 1 : 0) +
        (!!filterState.connectionStatus ? 1 : 0)
        + (!!filterState.haulType ? 1 : 0)
    );
};

export const getHaulTypeLabels = (t: TFunction): Record<string, string> => ({
    Long: t('HaulType_Long', 'Long Haul'),
    Short: t('HaulType_Short', 'Short Haul'),
});